<template>
  <div class="table-group">
    <div class="group-title">工艺列表</div>
    <vxe-grid
      ref="xTable"
      :min-height="tableConfig.minHeight"
      :toolbar-config="tableConfig.toolbarConfig"
      :edit-config="tableConfig.editConfig"
      :row-config="tableConfig.rowConfig"
      :mouse-config="tableConfig.mouseConfig"
      :keyboard-config="tableConfig.keyboardConfig"
      :footer-method="tableFooterMethod"
      :columns="tableColumn"
      :data="selfList"
      :show-footer="!!selfList.length"
    >
      <!-- 拖拽排序 -->
      <template #default_move>
        <span v-if="!disabled" class="iconfont icon-drag cursor-move"></span>
      </template>
      <!-- slot_default -->
      <template #default_seq="{ rowIndex }"> 工序{{ rowIndex + 1 }} </template>
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image
          v-if="row.list_chan_pin_tu"
          :list.sync="row.list_chan_pin_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_name="{ row, rowIndex }">
        <div class="flex flex-x-between flex-y-center">
          <el-input
            v-model="row.name"
            size="mini"
            class="flex-1"
            :disabled="disabled"
            @focus="focusName(rowIndex)"
            @blur="blurName"
            @input="changeName(row.name)"
          >
            <el-link
              slot="append"
              v-if="!disabled"
              class="m-l-5"
              type="primary"
              :underline="false"
              @click="chooseMuBan(rowIndex)"
            >
              选择工艺
            </el-link>
          </el-input>
        </div>
        <div
          v-if="muBanList.length && isShowFastList && rowIndex === activeRowIndex"
          class="fast-list"
        >
          <div
            v-for="(item, index) in muBanList"
            :key="index"
            class="fast-item"
            @click="doShangPin(item)"
          >
            {{ item.mu_ban_ming_cheng }}
          </div>
        </div>
      </template>
      <template #default_list_gong_cheng_tu="{ row }">
        <e-upload-image
          :list.sync="row.list_gong_cheng_tu"
          :limit="2"
          :disabled="disabled"
          isDelete
        />
      </template>
      <template #default_list_yuan_wen_jian="{ row }">
        <e-upload-file :list.sync="row.list_yuan_wen_jian" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_mu_ban="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_mu_ban" :disabled="disabled" isDelete />
      </template>
      <template #default_list_jian_ce_bao_gao="{ row }">
        <e-upload-file :list.sync="row.list_jian_ce_bao_gao" :disabled="disabled" isDelete />
      </template>
      <template #default_jin_du="{ row }">
        <div class="flex">
          <div class="flex flex-y-center" v-for="(item, index) in jin_du_list" :key="index">
            <span v-if="index">-</span>
            <el-link v-if="row.jin_du === index" type="primary">{{ item }}</el-link>
            <el-link v-if="row.jin_du > index" type="success">{{ item }}</el-link>
            <el-link v-if="row.jin_du < index" type="danger">{{ item }}</el-link>
          </div>
        </div>
      </template>
      <template #default_do="{ rowIndex }">
        <el-link v-if="!disabled" type="success" @click="rowAdd">增行</el-link>
        <el-link v-if="!disabled" type="danger" @click="rowDelete(rowIndex)"> 删行 </el-link>
      </template>

      <!-- slot_edit -->
      <template #edit_spec="{ row }">
        <el-input v-model="row.spec" type="text" size="mini" />
      </template>
      <template #edit_unit="{ row }">
        <el-input v-model="row.unit" type="text" size="mini" />
      </template>
      <template #edit_counts="{ row }">
        <el-input v-model="row.counts" type="number" size="mini" />
      </template>
      <template #edit_goods_price="{ row }">
        <el-input v-model="row.goods_price" type="number" size="mini" @input="calcAmount(row)" />
      </template>
      <template #edit_remark="{ row }">
        <el-input v-model="row.remark" type="text" size="mini" />
      </template>

      <!-- 数据为空 -->
      <template #empty>
        <div class="flex flex-center">
          <span class="c-gray-light">暂无数据</span>
          <el-link v-if="!disabled" class="m-l-10" type="success" @click="rowAdd">增行</el-link>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    mainData: {
      type: Object,
      required: true
    },
    mainUnit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      isShowFastList: false,
      muBanList: [],
      activeRowIndex: null,
      jin_du_list: ['待加工', '加工中', '已完成'],
      tableColumn: [
        {
          fixed: 'left',
          title: '排序',
          width: 40,
          slots: { default: 'default_move' }
        },
        {
          title: '工艺顺序',
          slots: { default: 'default_seq' },
          width: 63
        },
        {
          title: '工艺图片',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '工艺名称',
          field: 'name',
          slots: { default: 'default_name' },
          width: 144
        },
        {
          title: '规格(mm)',
          field: 'spec',
          slots: { edit: 'edit_spec' },
          editRender: { autofocus: '.el-input__inner' },
          width: 100
        },
        {
          title: '单位',
          field: 'unit',
          slots: { edit: 'edit_unit' },
          editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '数量',
          field: 'counts',
          // slots: { edit: 'edit_counts' },
          // editRender: { autofocus: '.el-input__inner' },
          width: 70
        },
        {
          title: '单价',
          field: 'goods_price',
          slots: { edit: 'edit_goods_price' },
          editRender: { autofocus: '.el-input__inner' },
          width: 80
        },
        {
          title: '金额',
          field: 'goods_amount',
          width: 80
        },
        {
          title: '工程图',
          field: 'list_gong_cheng_tu',
          slots: { default: 'default_list_gong_cheng_tu' },
          width: 63
        },
        {
          title: '源文件',
          field: 'list_yuan_wen_jian',
          slots: { default: 'default_list_yuan_wen_jian' },
          width: 80
        },
        {
          title: '检测模板',
          field: 'list_jian_ce_mu_ban',
          slots: { default: 'default_list_jian_ce_mu_ban' },
          width: 80
        },
        {
          title: '检测报告',
          field: 'list_jian_ce_bao_gao',
          slots: { default: 'default_list_jian_ce_bao_gao' },
          width: 80
        },
        {
          title: '进度',
          field: 'jin_du',
          slots: { default: 'default_jin_du' },
          width: 132
        },
        {
          title: '备注',
          field: 'remark',
          slots: { edit: 'edit_remark' },
          editRender: { autofocus: '.el-input__inner' },
          width: 120
        },
        {
          title: '操作',
          slots: { default: 'default_do' }
        }
      ],
      selfList: []
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let disabled = this.disabled
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return !disabled
          }
        },
        keyboardConfig: {
          isEdit: !disabled
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    list: {
      handler(val) {
        if (JSON.stringify(this.selfList) !== JSON.stringify(val)) {
          this.selfList = this.$util.deepCopy(val)
        }
      },
      deep: true,
      immediate: true
    },
    selfList: {
      handler(val) {
        if (JSON.stringify(this.list) !== JSON.stringify(val)) {
          this.$emit('update:list', this.$util.deepCopy(val))
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    if (!this.disabled) this.rowDrop()
  },
  methods: {
    // 行拖拽排序
    rowDrop() {
      this.$nextTick(() => {
        let $table = this.$refs.xTable
        if (!$table) return
        let $sortContent = $table.$el.querySelector('.body--wrapper>.vxe-table--body tbody')
        this.sortable = Sortable.create($sortContent, {
          handle: '.icon-drag',
          animation: 150,
          onEnd: ({ newIndex, oldIndex }) => {
            if (newIndex === oldIndex) return
            let data = this.$util.deepCopy(this.selfList)
            let oldItem = this.$util.deepCopy(data[oldIndex])
            if (newIndex < oldIndex) {
              data.splice(oldIndex, 1)
              if (newIndex === 0) {
                data.unshift(oldItem)
              } else {
                data.splice(newIndex, 0, oldItem)
              }
            }
            if (newIndex > oldIndex) {
              if (newIndex === data.length - 1) {
                data.push(oldItem)
                data.splice(oldIndex, 1)
              } else {
                data.splice(newIndex + 1, 0, oldItem)
                data.splice(oldIndex, 1)
              }
            }
            this.selfList = this.$util.deepCopy(data)
          }
        })
      })
    },
    // 名称输入框-获取焦点时，显示模板列表
    focusName(rowIndex) {
      this.activeRowIndex = rowIndex
      this.isShowFastList = true
      this.getMuBanListData(this.selfList[rowIndex].name)
    },
    // 名称输入框-失去焦点时，隐藏模板列表
    blurName() {
      setTimeout(() => {
        this.isShowFastList = false
      }, 300)
    },
    // 名称改变时，更新模板列表
    changeName(name) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.getMuBanListData(name)
        this.timer = null
      }, 300)
    },
    // 获取模板列表数据
    async getMuBanListData(name) {
      await this.$api({
        method: 'post',
        url: '/admin/gcvip/gongyi/list3',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          sortData: {
            id: 'desc'
          },
          filterData: {
            status: true,
            mu_ban_ming_cheng: name
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.muBanList = res.data.page.list
          }
        })
        .catch(() => {})
    },
    // 选择商品
    chooseMuBan(index) {
      this.$emit('chooseMuBan', index)
    },
    // 选择工艺模板
    doShangPin(item) {
      this.isShowFastList = false
      this.$emit('doShangPin', { item, rowIndex: this.activeRowIndex })
    },
    // 行-增行
    rowAdd() {
      let result = this.$util.deepCopy(this.$constant.newTableSaleSubObj)
      result.spec = this.mainData.spec
      result.counts = this.mainData.counts
      result.unit = this.mainData.unit || this.mainUnit
      this.selfList.push(result)
    },
    // 行-删行
    rowDelete(index) {
      this.selfList.splice(index, 1)
    },
    // 表格底部
    tableFooterMethod({ columns, data }) {
      // 重新计算行金额，修复金额合计不是最新结果的问题
      data.forEach((item) => {
        let a = Number(item.goods_price)
        let b = Number(item.counts)
        item.goods_amount = this.$XEUtils.multiply(a, b)
      })
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (['counts', 'goods_price', 'goods_amount'].includes(column.field)) {
            return this.$tool.listAddTotal(data, column.field)
          }
        })
      ]
    },
    // 单价变化时重新计算金额
    calcAmount(row) {
      row.goods_amount = this.$XEUtils.multiply(Number(row.goods_price), Number(row.counts))
    }
  }
}
</script>

<style lang="less" scoped>
.table-group {
  margin-bottom: 15px;
  .fast-list {
    position: absolute;
    top: 29px;
    left: 2px;
    width: 138px;
    max-height: 226px;
    overflow-y: auto;
    .scroll-bar();
    background: @colorWhite;
    border: @border;
    z-index: 99;
    .fast-item {
      padding: 0 5px;
      line-height: 28px;
      cursor: pointer;
      &:hover {
        background: @colorBlue20;
      }
    }
  }
}
</style>
